<div class="ir-login-image-wrapper">
  <img class="ir-login-image" src="../../assets/img/nashlogo.jpg" alt="Logo" width="100" />
</div>
<div class="position-absolute top-0 start-50 translate-middle-x mt-3 text-white fw-semibold text-center login-title pointer-events-none">
  <span class="d-none d-sm-inline fs-3">NASH Pro</span>
</div>
<div class="container">
  <div class="row justify-content-center">
    <div class="card password-recovery-wrapper">
      <div class="card-header">
        <h3>{{ 'LOGIN.RESET_PASSWORD' | translate }}</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="userForm" class="d-flex flex-column justify-content-between">
          <div class="form-group">
            <label for="user">{{ 'LOGIN.USER' | translate }}</label>

            <input
              class="form-control"
              id="user"
              placeholder="{{ 'LOGIN.USER' | translate }}*"
              formControlName="user"
              name="user"
              type="text"
              [ngClass]="{ 'input-error': user?.touched && user?.invalid }"
              (keyup)="enableReset()" />
            <small class="text-muted fs-6">{{ 'LOGIN.RECOVERY_INSTRUCTIONS' | translate }}</small>
          </div>
          <div class="form-actions">
            <button class="form-control form-control-lg" [disabled]="!enableReset()" type="button" (click)="resetPassword()">
              {{ 'LOGIN.SEND_RESET_LINK' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
